import css from './ReceiptSkeleton.module.scss'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { TICKETSMS_COLORS_LIGHTGREY, TICKETSMS_COLORS_MEDIUMGREY } from 'utils/constants/colors'

import Img from 'components/Media/Img'

const ReceiptSkeleton: React.FC = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.box}>
        <div className={css.logo}>
          <Img alt="TicketSMS Logo" src="/logo/TicketSms_logo.svg" />
        </div>
        <div className={css.transaction}>
          <Skeleton
            className={css.content_skeleton}
            baseColor={TICKETSMS_COLORS_MEDIUMGREY}
            borderRadius={8}
            highlightColor={TICKETSMS_COLORS_LIGHTGREY}
          />
        </div>
        <div className={css.quantities}>
          <Skeleton
            className={css.content_skeleton}
            baseColor={TICKETSMS_COLORS_MEDIUMGREY}
            borderRadius={8}
            highlightColor={TICKETSMS_COLORS_LIGHTGREY}
          />
        </div>
        <div className={css.totals}>
          <Skeleton
            className={css.content_skeleton_small}
            baseColor={TICKETSMS_COLORS_MEDIUMGREY}
            borderRadius={8}
            highlightColor={TICKETSMS_COLORS_LIGHTGREY}
          />
        </div>
        <div className={css.bottom}>
          <Img alt="Live your time" src="/receipt/bottom.svg" />
        </div>
      </div>
    </div>
  )
}

export default ReceiptSkeleton
